import { Navigate, redirect, RouteObject } from "react-router-dom";
import ErrorPage from "@pages/ErrorPage";
import Base from "@pages/Base";
import Dashboard from "@pages/Dashboard";
import Campaigns from "@pages/Campaigns/Campaigns";
import EmailAccounts from "@pages/EmailAccounts/EmailAccounts";
import AuthBase from "@pages/AuthBase";
import Login from "@pages/Login";
import Signup from "@pages/Signup";
import { clearTokens, retrieveTokens } from "@lib/jwt";
import axios from "axios";
import ConnectExistingDomain from "@pages/EmailAccounts/ConnectExistingDomain";
import ConnectDomainOptions from "@pages/EmailAccounts/ConnectDomainOptions";
import CreateCampaign from "@pages/Campaigns/CreateCampaign";
import CampaignSetup from "@pages/Campaigns/CampaignSetup";
import CampaignDetails from "@pages/Campaigns/CampaignDetails";
import UnsubscribeEmail from "@pages/UnsubscribeEmail";
import Integration from "@pages/Integrations/Integration";
import GoogleAuthCallback from "@pages/Integrations/GoogleAuthCallback";
import Postmaster from "@pages/Integrations/Postmaster";
import ForgotPassword from "@pages/ForgotPassword";
import ChangePassword from "@pages/ChangePassword";
import SettingsPage from "@pages/SettingsPage";
import AdminBase from "@admin/AdminBase";
import AdminDashboard from "@admin/AdminDashboard";
import AdminSpamWords from "@admin/AdminSpamWords";
import AdminSalutations from "@admin/AdminSalutations";
import AdminAllowedTLDs from "@admin/AdminAllowedTLDs";
import AdminBurntPatterns from "@admin/AdminBurntPatterns";
import AdminBurntDomains from "@admin/AdminBurntDomains";
import AdminUsers from "@admin/AdminUsers";
import Emails from "@pages/EmailAccounts/Emails";
import AdminUserDetails from "@admin/AdminUserDetails";
import AdminUserWorkspaces from "@admin/AdminUserWorkspaces";
import AdminUserConnectedDomains from "@admin/AdminUserConnectedDomains";
import AdminUserEmails from "@admin/AdminUserEmails";
import AdminUserCampaigns from "@admin/AdminUserCampaigns";
import AdminUserCampaignDetails from "@admin/AdminUserCampaignDetails";
import FAQPage from "@pages/FAQPage";
import ManageSubscription from "@pages/ManageSubscription";
import AdminSubscriptionPlans from "@admin/AdminSubscriptionPlans";
import AdminCreateSubscriptionPlan from "@admin/AdminCreateSubscriptionPlan";
import AdminEditSubscriptionPlan from "@admin/AdminEditSubscriptionPlan";
import CheckoutSuccess from "@pages/CheckoutSuccess";
import PlanUpdateSuccess from "@pages/PlanUpdateSuccess";
import OnboardingBase from "@pages/OnboardingBase";
import SignupPlanSelection from "@pages/SignupPlanSelection";
import AdminApprovalRequest from "@admin/AdminApprovalRequest";
import AdminApiAbuse from "@admin/AdminApiAbuse";
import CreditHistory from "@pages/CreditHistory";
import AdminUpdate from "@admin/AdminUpdate";
import Updates from "@pages/Updates";
import AccountEmailVerification from "@pages/AccountEmailVerification"
import ContactLists from "@pages/ContactLists";
import ContactListDetails from "@pages/ContactListDetails";
import AdminAllCampaign from "@admin/AdminAllCampaign";
import IntegrationPage from "@pages/Integrations/IntegrationPage";
import AdminSpamChecker from "@admin/AdminSpamChecker";
import AdminIntegrations from "@admin/AdminIntegrations";
import AdminBlacklists from "@admin/AdminBlacklist";
import AdminSendingHistory from "@admin/AdminSendingHistory";
import AdminSurveys from "@admin/AdminSurveys";
import AdminDripCampaign from "@admin/AdminDripCampaign";
import AdminSurveyQuestions from "@admin/AdminSurveyQuestions";
import AdminCreateSurveyQuestion from "@admin/AdminCreateSurveyQuestion";
import AdminEditSurveyQuestion from "@admin/AdminEditSurveyQuestion";
import AdminSurveyResponses from "@admin/AdminSurveyResponses";
import AdminSurveyAnalytics from "@admin/AdminSurveyAnalytics";
import AdminUserCreditLogs from "@admin/AdminUserCreditLogs";
import AdminAllDomains from "@admin/AdminAllDomains";
import AdminEmailSettings from "@admin/AdminEmailSettings";
import AdminConnectDomain from "@admin/AdminConnectDomain";
import AdminMaintenanceMode from "@admin/AdminMaintenanceMode";
import AdminFreeEmailVerification from "@admin/AdminFreeEmailVerification";
import AdminUserIntegrations from "@admin/AdminUserIntegration"
import AdminNSSettings from "@admin/AdminNSRecord";
import AdminUserContactList from "@admin/AdminUserContactList";
import AdminBlockedEmailDomains from "@admin/AdminBlockedEmailDomains";
import AdminWarmupMonitor from "@admin/AdminWarmupMonitor";
import AdminManageSystem from "@admin/AdminManageSystem";
import AdminPostmasterFbl from "@admin/AdminPostmasterFbl";
import AdminGooglePostmasterPage from "@admin/AdminGooglePostmasterPage";
import AdminGoogleAuthCallback from "@admin/AdminGoogleAuthCallback";
import AdminGooglePostmasterStats from "@admin/AdminGooglePostmasterStats";
import AdminGooglePostmasterTab from "@admin/AdminGooglePostmasterDomainStats";
import AdminBlockEmails from "@admin/AdminBlockEmails"
import AdminWarmupSystem from "@admin/AdminWarmupSystem"
import AdminUserDeliverymanAPIKey from "@admin/AdminUserDeliverymanAPIKey";
import AdminUserContactListDetails from "@admin/AdminUserContactListDetails";
import AdminUserEmailVerificationLists from "@admin/AdminUserEmailVerificationLists";
import AdminEmailVerificationResults from "@admin/AdminEmailVerificationResults";
import AdminContactListDetails from "@admin/AdminContactListDetails";
import AdminCreateCampaigns from "@admin/AdminCreateCampaigns";
import AdminFeatureFlags from "@admin/AdminFeatureFlags";
import AdminPostalSuppression from "@admin/AdminPostalSuppression";
import AdminPostalBounces from "@admin/AdminPostalBounces";
import AdminOnboardingQuestion from "@admin/AdminOnboardingQuestion";

export const urls = {
	// Admin
	"adminDashboard": "/admin/dashboard",
	"adminAllUsers": "/admin/users",
	"adminUserDetails": "/admin/users/:userId",
	"adminUserWorkspaces": "/admin/users/:userId/workspaces",
	"adminUserConnectedDomains": "/admin/users/:userId/connected-domains",
	"adminUserEmails": "/admin/users/:userId/emails",
	"adminUserCampaigns": "/admin/users/:userId/campaigns",
	"adminUserCampaignDetails": "/admin/users/:userId/campaigns/:campaignUID",
	"adminSpamWords": "/admin/spam-words",
	"adminSalutationWords": "/admin/salutation-words",
	"adminAllowedTLDs": "/admin/allowed-tlds",
	"adminBurntPatterns": "/admin/burnt-patterns",
	"adminBurntDomains": "/admin/burnt-domains",
	"adminSubscriptionPlans": "/admin/subscription-plans",
	"adminCreateSubscriptionPlans": "/admin/subscription-plans/create",
	"adminEditSubscriptionPlan": "/admin/subscription-plan/edit/:planId",
	"adminEmailContentApproval": "/admin/email-content-approval",
	"adminApiAbuse": "/admin/api-abuse",
	"adminUpdate": "/admin/update",
	"adminAllCampaign": "/admin/all-campaign",
	"adminIntegrations": "/admin/integrations",
	"adminBlacklist": "/admin/blacklist",
	"adminUserSendingHistory": "/admin/users/:userId/sending-history",
	"adminUserCreditLogs": "/admin/users/:userId/credit-logs",
	"adminSpamChecker": "/admin/spam-checker",
	"adminDripCampaign": "/admin/drip-campaign",
	"adminSurveys": "/admin/surveys",
	"adminSurveyQuestions": "/admin/survey/questions",
	"adminCreateSurveyQuestion": "/admin/survey/questions/create",
	"adminEditSurveyQuestion": "/admin/survey/questions/:questionUid/edit",
	"adminSurveyResponses": "/admin/survey/responses",
	"adminSurveyAnalytics": "/admin/survey/analytics/:surveyUid",
	"adminAllDomains": "/admin/all-domains",
	"adminEmailSettings": "/admin/email-settings",
	"adminMaintenanceMode": "/admin/maintenance-mode",
	"adminConnectDomain": "/admin/users/:userId/:workspaceId/connect-domain",
	"adminUserIntegrations": "/admin/users/:userId/user-integrations",
	"adminNsSetting": "/admin/ns-settings",
	"adminUserContactList": "/admin/users/:userId/contact-lists",
	"adminUserContactListDetails": "/admin/users/:userId/contact-lists/:contactListUID",
	"adminUserEmailVerificationLists": "/admin/users/:userId/email-verification-submissions",
	"adminEmailVerificationResults": "/admin/email-verification-results",
	"adminFreeEmailVerification": "/admin/free-email-verification",
	"adminUserDeliverymanAPIKey": "/admin/users/:userId/deliveryman-api-keys",
	"adminBlockedEmailDomains": "/admin/blocked-email-domains",
	// "adminWarmupMonitor": "/admin/warmup-monitor",
	"adminManageSystem": "/admin/manage-system",
	"adminPostmasterFbl": "/admin/postmaster-fbl",
	"adminGooglePostmasterPage": "/admin/google-postmaster-domain",
	"adminGoogleAuthCallback": "/admin/google-auth/callback/",
	"adminGooglePostmasterTab": "/admin/google-postmaster-stats",
	"adminBlockEmails": "/admin/manage-block-emails",
	"adminWarmupSystem": "/admin/warmup-system",
	"adminContactListDetails": "/admin/user-contact-list/:userId/:contactListUID",
	"adminCreateCampaigns": "/admin/users/:userId/:workspaceId/create-campaign",
	"adminFeatureFlags": "/admin/feature-flags",
	"adminPostalSuppression": "/admin/postal-suppression",
	"adminPostalBounces": "/admin/postal-bounces",
	"adminOnboardingQuestion": "/admin/onboarding-question",

	// User
	"login": "/auth/login",
	"signup": "/auth/signup",
	"signupPlanSelection": "/onboarding/plan-selection",
	"resetPassword": "/auth/reset-password",
	"changePassword": "/auth/change-password",
	"logout": "/logout",
	"accountEmailVerification": "/auth/verify-account-email/:token",

	"dashboard": "/dashboard",
	"settings": "/settings",
	"faq": "/faq",
	"manageSubscription": "/manage-subscription",
	"checkoutSuccess": "/checkout/success",
	"planUpdateSuccess": "/plan-update/success",

	"emailAccounts": "/email-accounts",
	"emails": "/email-accounts/emails/:domain",
	"connectDomainOptions": "/email-accounts/connect",
	"connectNewDomain": "/email-accounts/connect/existing",

	"contactLists": "/contact-lists",
	"contactListDetails": "/contact-lists/:contactListUID",

	"campaigns": "/campaigns",
	"createCampaign": "/campaigns/create",
	"campaignSetup": "/campaigns/:campaignUID/setup/",
	"campaignEmailDetails": "/campaigns/:campaignUID/",

	"integrations": "/integrations/",
	"googlePostmaster": "/integrations/google-postmaster/",
	"integrationPage": "/integrations-page/",

	"googleAuthCallback": "/google-auth/callback/",

	"unsubscribe": "/unsubscribe/",

	"SendingHistory": "/sending-history/",

	"Updates": "/updates/"

}

const routes: RouteObject[] = [
	{
		path: "/auth",
		element: <AuthBase />,
		id: "authBase",
		errorElement: <ErrorPage />,
		children: [
			{
				index: true,
				element: <Navigate to={urls["login"]} replace={true} />
			},
			{
				path: urls["login"],
				element: <Login />,
			},
			{
				path: urls["signup"],
				element: <Signup />,
			},
			{
				path: urls["resetPassword"],
				element: <ForgotPassword />,
			},
			{
				path: urls["changePassword"],
				element: <ChangePassword />,
			},
			{
				path: urls['accountEmailVerification'],
				element: <AccountEmailVerification />
			},
		]
	},
	{
		path: "/onboarding",
		element: <OnboardingBase />,
		id: "onboarding",
		errorElement: <ErrorPage />,
		children: [
			{
				path: urls["signupPlanSelection"],
				element: <SignupPlanSelection />,
			}
		]
	},
	{
		path: urls["logout"],
		loader: async () => {
			return await logoutUser();
		}
	},
	{
		path: "/admin",
		element: <AdminBase />,
		id: "adminbase",
		children: [
			{
				index: true,
				element: <Navigate to={urls["adminDashboard"]} replace={true} />
			},
			{
				path: urls["adminDashboard"],
				element: <AdminDashboard />,
			},
			{
				path: urls["adminAllUsers"],
				element: <AdminUsers />,
			},
			{
				path: urls["adminUserDetails"],
				element: <AdminUserDetails />,
			},
			{
				path: urls["adminUserWorkspaces"],
				element: <AdminUserWorkspaces />,
			},
			{
				path: urls["adminUserConnectedDomains"],
				element: <AdminUserConnectedDomains />,
			},
			{
				path: urls["adminUserEmails"],
				element: <AdminUserEmails />,
			},
			{
				path: urls["adminUserCampaigns"],
				element: <AdminUserCampaigns />,
			},
			{
				path: urls["adminUserCampaignDetails"],
				element: <AdminUserCampaignDetails />,
			},
			{
				path: urls["adminSpamWords"],
				element: <AdminSpamWords />,
			},
			{
				path: urls["adminSalutationWords"],
				element: <AdminSalutations />,
			},
			{
				path: urls["adminAllowedTLDs"],
				element: <AdminAllowedTLDs />,
			},
			{
				path: urls["adminBurntPatterns"],
				element: <AdminBurntPatterns />,
			},
			{
				path: urls["adminBurntDomains"],
				element: <AdminBurntDomains />,
			},
			{
				path: urls["adminSubscriptionPlans"],
				element: <AdminSubscriptionPlans />,
			},
			{
				path: urls["adminCreateSubscriptionPlans"],
				element: <AdminCreateSubscriptionPlan />,
			},
			{
				path: urls["adminEditSubscriptionPlan"],
				element: <AdminEditSubscriptionPlan />,
			},
			{
				path: urls["adminEmailContentApproval"],
				element: <AdminApprovalRequest />,
			},
			{
				path: urls["adminApiAbuse"],
				element: <AdminApiAbuse />,
			},
			{
				path: urls["adminUpdate"],
				element: <AdminUpdate />,
			},
			{
				path: urls["adminAllCampaign"],
				element: <AdminAllCampaign />,
			},
			{
				path: urls["adminIntegrations"],
				element: <AdminIntegrations />,
			},
			{
				path: urls["adminSpamChecker"],
				element: <AdminSpamChecker />,
			},
			{
				path: urls["adminBlacklist"],
				element: <AdminBlacklists />,
			},
			{
				path: urls["adminEmailSettings"],
				element: <AdminEmailSettings />,
			},
			{
				path: urls["adminUserSendingHistory"],
				element: <AdminSendingHistory />,
			},
			{
				path: urls["adminDripCampaign"],
				element: <AdminDripCampaign />,
			},
			{
				path: urls["adminSurveys"],
				element: <AdminSurveys />,
			},
			{
				path: urls["adminSurveyQuestions"],
				element: <AdminSurveyQuestions />,
			},
			{
				path: urls["adminCreateSurveyQuestion"],
				element: <AdminCreateSurveyQuestion />,
			},
			{
				path: urls["adminEditSurveyQuestion"],
				element: <AdminEditSurveyQuestion />,
			},
			{
				path: urls["adminSurveyResponses"],
				element: <AdminSurveyResponses />,
			},
			{
				path: urls["adminSurveyAnalytics"],
				element: <AdminSurveyAnalytics />,
			},
			{
				path: urls["adminUserCreditLogs"],
				element: <AdminUserCreditLogs />,
			},
			{
				path: urls["adminUserContactList"],
				element: <AdminUserContactList />,
			},
			{
				path: urls["adminUserContactListDetails"],
				element: <AdminUserContactListDetails />,
			},
			{
				path: urls["adminUserEmailVerificationLists"],
				element: <AdminUserEmailVerificationLists />,
			},
			{
				path: urls["adminEmailVerificationResults"],
				element: <AdminEmailVerificationResults />,
			},
			{
				path: urls["adminUserDeliverymanAPIKey"],
				element: <AdminUserDeliverymanAPIKey />,
			},
			{
				path: urls["adminAllDomains"],
				element: <AdminAllDomains />,
			},
			{
				path: urls["adminMaintenanceMode"],
				element: <AdminMaintenanceMode />,
			},
			{
				path: urls["adminFreeEmailVerification"],
				element: <AdminFreeEmailVerification />,
			},
			{
				path: urls["adminConnectDomain"],
				element: <AdminConnectDomain />,
			},
			{
				path: urls["adminUserIntegrations"],
				element: <AdminUserIntegrations />,
			},
			{
				path: urls["adminNsSetting"],
				element: <AdminNSSettings />,
			},
			{
				path: urls["adminBlockedEmailDomains"],
				element: <AdminBlockedEmailDomains />,
			},
			// {
			// 	path: urls["adminWarmupMonitor"],
			// 	element: <AdminWarmupMonitor />,
			// },
			{
				path: urls["adminManageSystem"],
				element: <AdminManageSystem />,
			},
			{
				path: urls["adminPostmasterFbl"],
				element: <AdminPostmasterFbl />,
			},
			{
				path: urls["adminGooglePostmasterPage"],
				element: <AdminGooglePostmasterPage />,
			},
			{
				path: urls["adminGoogleAuthCallback"],
				element: <AdminGoogleAuthCallback />,
			},
			{
				path: urls["adminGooglePostmasterTab"],
				element: < AdminGooglePostmasterTab />,
			},
			{
				path: urls["adminBlockEmails"],
				element: <AdminBlockEmails />,
			},
			{
				path: urls["adminWarmupSystem"],
				element: <AdminWarmupSystem />,
			},
			{
				path: urls["adminPostalSuppression"],
				element: <AdminPostalSuppression />,
			},
			{
				path: urls["adminPostalBounces"],
				element: <AdminPostalBounces />,
			},
			{
				path: urls["adminContactListDetails"],
				element: <AdminContactListDetails />
			},
			{
				path: urls["adminCreateCampaigns"],
				element: <AdminCreateCampaigns />,
			},
			{
				path: urls["adminFeatureFlags"],
				element: <AdminFeatureFlags />,
			},
			{
				path: urls["adminOnboardingQuestion"],
				element: <AdminOnboardingQuestion />,
			},
		]
	},
	{
		path: "/",
		element: <Base />,
		id: "base",
		errorElement: <ErrorPage />,
		children: [
			{
				index: true,
				element: <Navigate to={urls["dashboard"]} replace={true} />
			},
			{
				path: urls["dashboard"],
				element: <Dashboard />,
			},
			{
				path: urls["settings"],
				element: <SettingsPage />,
			},
			{
				path: urls["faq"],
				element: <FAQPage />,
			},
			{
				path: urls["manageSubscription"],
				element: <ManageSubscription />,
			},
			{
				path: urls["checkoutSuccess"],
				element: <CheckoutSuccess />,
			},
			{
				path: urls["planUpdateSuccess"],
				element: <PlanUpdateSuccess />,
			},
			{
				path: urls["emailAccounts"],
				element: <EmailAccounts />,
			},
			{
				path: urls["emails"],
				element: <Emails />,
			},
			{
				path: urls["connectNewDomain"],
				element: <ConnectExistingDomain />,
			},
			{
				path: urls["connectDomainOptions"],
				element: <ConnectDomainOptions />,
			},
			{
				path: urls["campaigns"],
				element: <Campaigns />,
			},
			{
				path: urls["createCampaign"],
				element: <CreateCampaign />,
			},
			{
				path: urls["campaignSetup"],
				element: <CampaignSetup />,
			},
			{
				path: urls["campaignEmailDetails"],
				element: <CampaignDetails />,
			},
			{
				path: urls["contactLists"],
				element: <ContactLists />,
			},
			{
				path: urls["contactListDetails"],
				element: <ContactListDetails />,
			},
			{
				path: urls["integrations"],
				element: <Integration />,
			},
			{
				path: urls["googlePostmaster"],
				element: <Postmaster />,
			},
			{
				path: urls["googleAuthCallback"],
				element: <GoogleAuthCallback />,
			},
			{
				path: urls["SendingHistory"],
				element: <CreditHistory />
			},
			{
				path: urls["Updates"],
				element: <Updates />
			},
			{
				path: urls["integrationPage"],
				element: <IntegrationPage />,
			},

		]
	},
	{
		path: "/unsubscribe",
		element: <UnsubscribeEmail />,
		id: "unsubscribe",
		errorElement: <ErrorPage />,
	},
]

async function logoutUser() {
	// Send request to logout endpoint to blacklist current tokens
	try {
		await axios({
			method: "post",
			url: process.env.REACT_APP_BACKEND + "/auth/logout/",
			responseType: "json"
		});
	} catch (err) {
		// Logout failed due to client or server error. Return to dashboard page
		// Should not ideally happen.
		console.error(err);
		return redirect(urls['dashboard'])
	}

	// Delete any jwt tokens and redirect to login page
	clearTokens();
	document.cookie = 'logged=; path=/; max-age=0';
	return redirect(urls['login']);
}

export default routes;
